import classNames from 'classnames';
import type React from 'react';

type Props = {
  children: React.ReactNode;
  className?: string;
};

export const MenuItemsColumn = (props: Props) => (
  // gap-0.5 is used to avoid overlapping because menuItem has 2px outline for a focused item
  <div className={classNames('flex flex-col gap-0.5', props.className)}>
    {props.children}
  </div>
);
